/**
 * Layout / template UI/UX
 */

'use strict';

// Constructor
var FrontLayout = function () {
    this.stickyHeader();
    this.mobileHeaderMenu();
    this.initCookie();

    $(document).ready((function() {
        this.initMaterializeComponents();
        this.showHideBottomPopup();
        this.btnNewsletter();
        this.computeUiTitlesSeparator();
        this.sidebarDebug();
    }).bind(this));
};

FrontLayout.prototype = {
    stickyHeader: function() {
        if ($('#site-header').length > 0) {
            var header = $('#site-header');
            var sticky = $('#site-header nav');
            var stickyHeight = sticky.height();
            var threshold = sticky.offset().top;

            if ($('body').hasClass('landing') || $('#site-header .top').hasClass('hide')) {
                threshold = 1;
            }

            if ($(window).width() < 992) {
                threshold = 1;
            }

            if ($('#site-header .button-collapse').length > 0 && $('#site-header .button-collapse').is(':visible')) {
                // iPad landscape (1024 x 768)
                threshold = 1;
            }

            var addStickyStyle = function () {
                if (header.hasClass('force-no-sticky')) {
                    return;
                }

                var scroll = $(window).scrollTop();
                var currentHeight = Math.floor(sticky.height());

                if (scroll >= threshold) {
                    sticky.addClass('fixed');
                    header.css('margin-bottom', stickyHeight);
                    sticky.find('#desktop-menu li a').css('line-height', currentHeight + 'px');
                } else {
                    sticky.removeClass('fixed');
                    header.css('margin-bottom', '0px');
                    sticky.find('#desktop-menu li a').css('line-height', stickyHeight + 'px');
                }
            };

            $(window).scroll(function () {
                addStickyStyle();
            });

            addStickyStyle();
        }
    },

    mobileHeaderMenu: function() {
        $('#site-header .button-collapse').sidenav();
    },

    /**
     * Init the Collapsible Materialize Component.
     *
     * @param onOpen    Callback function on open
     * @param onClose   Callback function on close
     */
    initCollapsible: function (onOpen, onClose) {
        if (!$('main#content').find('.cm-collapsible').length > 0) {
            return;
        }

        // Replace "-" by "+" for collapsible content
        $('main#content').find('.cm-collapsible .collapsible-header').not('.active').find('.one-border').find('span i').html('add');
        $('main#content').find('.cm-collapsible .collapsible-header.active').find('.one-border').find('span i').html('remove');

        $('main#content ul.cm-collapsible').collapsible({
            onOpen: function (el) {
                el.find('.one-border').find('span i').html('remove');

                // Custom callback function
                if (typeof onOpen === "function") {
                    onOpen(el);
                }
            },
            onClose: function (el) {
                el.find('.one-border').find('span i').html('add');

                // Custom callback function
                if (typeof onOpen === "function") {
                    onClose(el);
                }
            }
        });
    },

    /**
     * Init the Materialize components.
     */
    initMaterializeComponents: function() {

        $('.fixed-action-btn').floatingActionButton();
        // TODO: manipulate arrrows upon expand/collapse
        $('.collapsible').collapsible();
        $('#productions .collapsible').collapsible({
            accordion: false
        });
        $('.collapsible.cm-collapsible').collapsible({
            accordion: false
        });

        $('.modal').modal({
            opacity: .7,
            startingTop: '4%', // Starting top style attribute
            endingTop: '10%', // Ending top style attribute
        });

        $(".input-field select").formSelect();

        // $('.input-field select').formSelect(function() {
        //     $('input.select-dropdown').trigger('close');
        // });

        var onMouseDown = function(e) {
            // preventing the default still allows the scroll, but blocks the blur.
            // We're inside the scrollbar if the clientX is >= the clientWidth.
            if (e.clientX >= e.target.clientWidth || e.clientY >= e.target.clientHeight) {
                e.preventDefault();
            }
        };

        $('.input-field select').siblings('input.select-dropdown').on('mousedown', onMouseDown);

        // Bug fix with Materialize multiple dropdown on iOS
        // cf. https://github.com/Dogfalo/materialize/issues/2319

        if (bowser.ios) {
            $(document).on('touchstart', function (e) {
                var target = $(e.target);
                if (!target.is("span")) { //checking if you are tapping on items in multiple select or not
                    $(document).trigger('click'); //if you are tapping outside multiple select close it
                    $(':focus').blur(); //focus out for multiple select so you can choose another or the same (in case you have more multiple selects on page)
                } else {
                    //nothing or fire another event
                };
            });

            /*$(document).bind('mousedown touchstart', function(e){
                $('ul.multiple-select-dropdown').each(function() {
                    var $dropdown = $(this);
                    if ($dropdown.css('display') == 'block') {
                        if ($dropdown.is(e.target) || $dropdown.find('*').is(e.target)) {
                            //console.log('test 11111');
                            //alert('test1111');
                            $(this).unbind(e);
                        } else if (!$dropdown.find('*').is(e.target)) {
                            //console.log('test 22222');
                            //alert('test2222');
                            $(this).unbind(e);
                        }
                    }
                });
            });*/
        }
    },

    /**
     * For mobile devices, use the browser default style to render dropdown (select) instead of MaterializeCSS.
     *
     * @param $parent   Parent container
     */
    disableMaterializeDropdownOnMobile: function($parent) {
        function useDefaultDropdown() {
            if ($(window).width() < 500) {
                $('select', $parent).each(function () {
                    if ($(this).attr("multiple")) {
                        // Do not modify select with "multiple" attribute
                        return true;
                    }

                    $(this).formSelect('destroy');
                    $(this).addClass('browser-default');
                    $(this).formSelect();
                });
            }
        }

        $(window).on('resize', function() {
            useDefaultDropdown();
        });

        // On page load
        useDefaultDropdown();
    },

    initCookie: function() {
        var self = this;

        if (!$('footer#site-footer').find('.bottom-popup').length > 0) {
            return;
        }

        var popupCookieName = 'hideBottomPopup';
        var popupDiv = $('.bottom-popup');

        // Expires date set to the day after today
        var expireDate = new Date((new Date()).valueOf() + 1000*3600*24).toUTCString();

        self.testCookie(popupCookieName, popupDiv);

        $('.bottom-popup .action-close').on('click', function() {     
            if (self.getCookie(popupCookieName).length < 1) {
                self.setCookie(popupCookieName, expireDate);
            }  

            self.showHideBottomPopup();
        });
    },

    showHideBottomPopup: function() {
        if ($('.bottom-popup').hasClass('open')) {
            var timeOut = 0;
            var bottomvalue = '-' + ($('.bottom-popup').css('height'));
        } else {
            var timeOut = 1200;
            var bottomvalue = '0px';
        }

        $('.bottom-popup').toggleClass('open');

        setTimeout(function () {
            $('footer#site-footer').find('.bottom-popup').animate({
                bottom: bottomvalue,
            }, 400);
        }, timeOut);
    },

    btnNewsletter: function() {
        $('#site-header .subscribeNewsletter').on('click', function() {
            if ($('body').hasClass('logged-in')) {
                window.location.href = comedien.user.urlSettings;
            } else {
                $('html, body').animate({
                    scrollTop: $("#site-footer").offset().top
                }, 1500, function() {
                    $('#site-footer #newsletterEmail').focus();
                });
            }
        });
    },

    /**
     * Compute the position of the horizontal title's separator.
     */
    computeUiTitlesSeparator: function() {
        var compute = function(element) {
            var containerWidth = $(element).width();
            var labelWidth = $('span', element).outerWidth(true);
            var separatorWidth = containerWidth - labelWidth;

            if (separatorWidth > 0) {
                $('hr', element).css({
                    'width': separatorWidth + 'px',
                    'opacity': 1,
                });
            }
        };

        $('main#content .title-section').each(function() {
            compute(this);
        });
    },

    sidebarDebug: function() {
        if ($('#slide-my-account').length > 0) {
            if ($('.local-debug').length > 0) {
                var html = '';
                var bodyClass = $('body').attr('class');

                html += bodyClass;

                var bodyClassArr = bodyClass.split(" ");
                $.each(bodyClassArr, function (index, value) {
                    if (value.indexOf('postid-') == 0) {
                        var parts = value.split("-");
                        if (parts.length == 2) {
                            var idPost = parseInt(parts[1]);
                            html += '<br /><br />';
                            html += '<a href="' + comedien.adminUrl + 'post.php?post=' + idPost + '&action=edit" target="_blank">Edit this post</a>';
                        }
                    }
                });

                $('#slide-my-account .local-debug .content').html(html);
            }

            if ($('#user_switching_switch_on').length > 0) {
                var $switchLink = $('#user_switching_switch_on a');
                $switchLink.addClass('btn btn-small btn-user-switching').attr('title', 'Se reconnecter en tant qu\'administrateur').html('<i class="material-icons">loop</i>');
                $switchLink.insertAfter('#slide-my-account #logout');
            }
        }
    },

    setCookie: function(cookieName, expirationDate) {
        document.cookie = cookieName + "=1;expires=" + expirationDate + ';path=/;secure ';    
    },

    testCookie: function(cookieName, divToHide) {
        var test = parseInt(this.getCookie(cookieName));
     
        if (test === 1) {
            divToHide.addClass('hidden');
        }
    },

    getCookie: function(cookieName) {
        var name = cookieName + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];

            while (c.charAt(0)==' ') {
                c = c.substring(1);
            }

            if (c.indexOf(name) == 0) {
                return c.substring(name.length,c.length);
            }
        }
        return "";
    },

    /**
     * Re-enable page scrolling
     */
    enableScroll: function() {
        // Enable scolling functionality
        $('body').off('scroll touchmove mousewheel');

        // Display scrollbar
        $('body').css('overflow', 'visible');
    },

    /**
     * Disable page scrolling
     */
    disableScroll: function() {
        // Disable scrolling functionality
        $('body').on('scroll touchmove mousewheel', function(e) {
            var $offsetParent = $(e.target.offsetParent);
            if ($offsetParent && $offsetParent.hasClass('dropdown-content')) {
                // Do not disable the mouse scroll when the parent element is a Materialize Dropdown
                return true;
            } else {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        });

        // Hide scrollbar
        $('body').css('overflow', 'hidden');
    },
};

module.exports = new FrontLayout();
